import React from 'react'
import { Switch, Route, RouteComponentProps } from 'react-router'

import { EditContainer } from './Edit'
import { ssoRealmsEdit, SSO_REALMS_CREATE_URL, SSO_REALMS_URL } from '../../../constants/urls/frontend'
import { CreateContainer } from './Create'
import { DisplayContainer } from './Display'

const SSORealmsPage: React.FC<RouteComponentProps> = (): JSX.Element => {
  return (
    <Switch>
      <Route path={ssoRealmsEdit()} component={EditContainer} />
      <Route path={SSO_REALMS_CREATE_URL} component={CreateContainer} />
      <Route path={SSO_REALMS_URL} component={DisplayContainer} />
    </Switch>
  )
}

export {
  SSORealmsPage
}
